import React, { useEffect, useState } from 'react';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import InputMask from 'react-input-mask';
import {useApi} from "app/api/APIProvider";
import { Title, TitleSize } from 'shared/ui/Title/Title';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { classNames } from 'shared/lib/classNames/classNames';
import { useDispatch, useSelector } from 'react-redux';
import { getUserData, userActions } from 'features/User';
import { useNavigate } from 'react-router-dom';
import cls from './SmsCode.module.scss';

type FormData = {
  code: string;
};

interface SmsCodeProps {
    className?: string,
    step: string,
    isSignedUp: boolean,
}

export const SmsCode: React.FC<SmsCodeProps> = ({ className, step, isSignedUp }) => {
    const api = useApi();
    const user = useSelector(getUserData);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [counter, setCounter] = useState<number>(30);
    const [timerActive, setTimerActive] = useState<boolean>(false);
    const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);

    const {
        control,
        handleSubmit,
        setValue,
        setError,
        formState: { errors },
    } = useForm<FormData>({ mode: 'onChange' });

    const onSubmit: SubmitHandler<FormData> = async (data) => {
        const cleanedCode = data.code.replace(/\D/g, '');
        if (cleanedCode.length === 6) {
            const newData = {
                phone: user.phone,
                sms: data.code.split('-').join('')
            };
            api.SendSms(newData as unknown as any).then(async (res) => {
                if (res.code === 0) {
                    const user = await api.GetUser();
                    if (!user.avatar || !user.avatar_name) {
                        navigate('avatar');
                    } else {
                        navigate('/');
                    }
                } else {
                    // setError('code', { message: res.message })
                    setError('code', { message: res.message });
                }
            })
        } else {
            setError('code', { message: 'Код должен должен состоять из 6 цифр' })
        }
    };

    useEffect(() => {
        if (timerActive) {
            setCounter(30);
            const id = setInterval(() => {
                setCounter(prevCounter => (prevCounter > 0 ? prevCounter - 1 : 0));
            }, 1000);

            setIntervalId(id);
            setTimerActive(false);
        }

        return () => {
            clearInterval(intervalId);
        };
    }, [timerActive]);

    useEffect(() => {
        setTimerActive(true)
    }, [step])

    const restartTimer = () => {
        if (isSignedUp) {
            api.SignIn({ phone: user.phone } as unknown as any).then((res) => {
                if (res.code !== 0) {
                    setError('code', { message: 'Превышен лимит' });
                }
            })
        } else {
            api.SignUp({ phone: user.phone } as unknown as any).then((res) => {
                if (res.code !== 0) {
                    setError('code', { message: 'Превышен лимит' });
                }
            })
        }
        setTimerActive(true);
    };


    return (
        <div className={cls.formWrapper}>
            <Title className={cls.title} color="#000000A6" size={TitleSize.title_32_400}>Введите код из СМС</Title>
            <Text className={cls.subtitle} color="#000000A6" size={TextSize.text_14}>
                Мы отправили код подтверждения на указанный вами номер
            </Text>
            <form className={cls.form} onSubmit={handleSubmit(onSubmit)}>
                <div className={cls.cell}>
                    <Controller
                        name="code"
                        control={control}
                        rules={{ required: 'Заполните поле' }}
                        render={({ field }) => (
                            <InputMask
                                className={cls.field}
                                mask="999-999"
                                maskChar="_"
                                value={field.value}
                                //@ts-ignore
                                onChange={(e) => {
                                    setError('code', { message: '' })
                                    setValue('code', e.target.value)
                                }}
                                placeholder="Смс код"
                            />
                        )}
                    />
                    {errors.code && <p className={cls.error}>{errors.code.message}</p>}
                </div>
                <Text className={classNames(cls.counter, { [cls.active]: counter !== 0 })} color="#000000A6" size={TextSize.text_14}>
                    Через {counter} секунд код можно получить повторно
                </Text>
                <Button type="button" className={classNames(`${cls.button} ${cls.resendButton}`, { [cls.active]: counter === 0 })} theme={ButtonTheme.TEXT} onClick={restartTimer}>
                    Запросить код повторно
                </Button>
                <Button type="submit" className={cls.button} theme={ButtonTheme.PRIMARY}>
                    Войти
                </Button>
            </form>
        </div>
    );
};


